import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import EfficiencySummary from 'containers/Dashboard/Efficiency/EfficiencySummary';
import TeepCards from 'containers/Dashboard/Efficiency/TeepCards';
import ScheduleCards from 'containers/Dashboard/Efficiency/ScheduleCards';
import AvailabilityCards from 'containers/Dashboard/Efficiency/AvailabilityCards';
import DowntimeCards from 'containers/Dashboard/Efficiency/DowntimeCards';
import PerformanceRunCards from 'containers/Dashboard/Efficiency/PerformanceRunCards';
import PerformanceSetupCards from 'containers/Dashboard/Efficiency/PerformanceSetupCards';
import QualityCards from 'containers/Dashboard/Efficiency/QualityCards';
import SharedCanvas from 'containers/Dashboard/components/SharedCanvas';
import { useDashboardContext } from 'containers/Dashboard/context/DashboardContext';

const SUMMARY_CANVASES = [
  'summary',
  'schedule',
  'availability',
  'performance',
  'quality',
];

function EfficiencyCanvas() {
  const { canvasId } = Route.useParams();
  const {
    authtoken,
    selectedDate,
    handleSelectedDateChange,
    handleDashboardNavigation,
    handleNavigation,
    teepData,
    resources,
    isLoading,
  } = useDashboardContext();

  if (SUMMARY_CANVASES.includes(canvasId)) {
    return (
      <EfficiencySummary
        authtoken={authtoken}
        selectedDate={selectedDate}
        selectedDashboardId="efficiency"
        selectedCanvasId={canvasId}
        handleSelectedDateChange={handleSelectedDateChange}
        handleDashboardNavigation={handleDashboardNavigation}
        teepData={teepData}
        resources={resources}
        handleNavigation={handleNavigation}
        isLoading={isLoading}
      />
    );
  }
  if (canvasId === 'summary_details') {
    return (
      <TeepCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  if (
    canvasId === 'schedule_downtime_details' ||
    canvasId === 'availability_downtime_details'
  ) {
    return (
      <DowntimeCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  if (canvasId === 'schedule_details') {
    return (
      <ScheduleCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  if (canvasId === 'availability_details') {
    return (
      <AvailabilityCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  if (canvasId === 'performance_run_details') {
    return (
      <PerformanceRunCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  if (canvasId === 'performance_setup_details') {
    return (
      <PerformanceSetupCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  if (canvasId === 'quality_details') {
    return (
      <QualityCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  return <SharedCanvas dashboard="efficiency" canvasId={canvasId} />;
}

export const Route = createFileRoute(
  '/_authenticated/dashboard/efficiency/$canvasId'
)({
  component: EfficiencyCanvas,
});
